import { render, staticRenderFns } from "./QuickButtons.vue?vue&type=template&id=44ee3b2a&"
import script from "./QuickButtons.vue?vue&type=script&lang=js&"
export * from "./QuickButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44ee3b2a')) {
      api.createRecord('44ee3b2a', component.options)
    } else {
      api.reload('44ee3b2a', component.options)
    }
    module.hot.accept("./QuickButtons.vue?vue&type=template&id=44ee3b2a&", function () {
      api.rerender('44ee3b2a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/common/dashboard/panels/channels/QuickButtons.vue"
export default component.exports